<template>
    <div>
        <label for="">Input Redeem code</label>
        <input type="text">
        <button @click="redeemTicket">Redeem</button>
        <img v-if="codeVerified" :src="imageURL">
    </div>
</template>
<script>
import firebase from 'firebase';
export default {
    data(){
        return {
            imageURL:'',
            codeVerified:false,
            code:''
        }
    },
    methods:{
        redeemTicket(){
            //Search /code get the ticketID

            console.log('Redeeming Ticket...');
            //Ticket add redeemed prop
            //Ticket be transfered under /plan
            //Ticket Face Image Swap
        }

    }
    
}
</script>
